import _ from 'lodash'
import isGeographicOrRollup from '../is-geographic-or-rollup'
import DataType from 'scoreboard/datasets/model/data-type'
const { YES_NO, DATE, DATE_TIME, TIME, CALENDAR_PERIOD } = DataType

// returns whether there are two steps in the filter wizard (if there aren't two
// steps there's just one step)
function twoSteps (dataType, operator) {
	if (isGeographicOrRollup(dataType) &&
		(operator === 'is-any' || operator === 'is-not-any' || operator === 'is')) {
		return true
	}

	if (dataType === YES_NO && operator === 'equals-equation') {
		return true
	}

	return _.includes([DATE, TIME, DATE_TIME, CALENDAR_PERIOD], dataType) &&
		_.includes(['before', 'after', 'between-date-time', 'in-period'],
			operator)
}

export default twoSteps

twoSteps.__filename__ = 'datasets/filters/two-steps.js'
